import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

export const queryClient = createQueryClient();

function createQueryClient() {
  const newClientQuery = new QueryClient({
    queryCache: new QueryCache({
      onError(error) {
        console.error("Query error:", error);
      },
    }),

    mutationCache: new MutationCache({
      onError(error) {
        console.error("Mutation error:", error);
      },
    }),

    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        useErrorBoundary: false,
      },
    },
  });

  return newClientQuery;
}
